/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const AnnouncementDtoMediaTypeEnum = {
    Image: 'image',
    Video: 'video'
};
/**
 * Check if a given object implements the AnnouncementDto interface.
 */
export function instanceOfAnnouncementDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('startAt' in value) || value['startAt'] === undefined)
        return false;
    if (!('endAt' in value) || value['endAt'] === undefined)
        return false;
    if (!('pinned' in value) || value['pinned'] === undefined)
        return false;
    if (!('highlighted' in value) || value['highlighted'] === undefined)
        return false;
    return true;
}
export function AnnouncementDtoFromJSON(json) {
    return AnnouncementDtoFromJSONTyped(json, false);
}
export function AnnouncementDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'mediaType': json['mediaType'] == null ? undefined : json['mediaType'],
        'mediaUrl': json['mediaUrl'] == null ? undefined : json['mediaUrl'],
        'linkUrl': json['linkUrl'] == null ? undefined : json['linkUrl'],
        'content': json['content'] == null ? undefined : json['content'],
        'startAt': json['startAt'],
        'endAt': json['endAt'],
        'pinned': json['pinned'],
        'highlighted': json['highlighted'],
    };
}
export function AnnouncementDtoToJSON(json) {
    return AnnouncementDtoToJSONTyped(json, false);
}
export function AnnouncementDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'mediaType': value['mediaType'],
        'mediaUrl': value['mediaUrl'],
        'linkUrl': value['linkUrl'],
        'content': value['content'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'pinned': value['pinned'],
        'highlighted': value['highlighted'],
    };
}
